(function () {
  'use strict';

  var module = angular.module('uwAgenda.ringfoon');

  module.factory('CallsService',
    ['$rootScope',
      '$http',
      '$uibModal',
      '$uibModalStack',
      'WebsocketService',
      'WebsocketRegisterType',
      'AgendaTransitionService',
      'ProtocolBroadcastService',
      'ProtocolFilter',
      'SharedAgendaService',
      'CallPhoneStatus', CallsServiceFn]);

  // main service for handling Calls
  function CallsServiceFn($rootScope,
                          $http,
                          $uibModal,
                          $uibModalStack,
                          WebsocketService,
                          WebsocketRegisterType,
                          AgendaTransitionService,
                          ProtocolBroadcastService,
                          ProtocolFilter,
                          SharedAgendaService,
                          CallPhoneStatus) {

    // websocket subscriber
    var ws = [];

    // non-websocket incoming call
    var incomingCall = {
      doctors: [],
      phoneNumber: '',
      selectedDoctor: null,
      isCallFromDoctor: false,
      doctorName: ''
    };

    // current call-data INGOING
    var call = {
      with: null, // current json-data from last call
      selected: null, // selected user/doctor/agenda 
      caller: null, // selected caller -> who is calling ?
      phoneStatus: null, // CONNECTED or IDLE
      wrapUp: {
        // wrap up status
        start: false, // if true -> show the option to wrap up pause
        time: null // how long show the wrap up ?
      },
      talkingTo: null, // phoneNumber to which we are currently talking
      opening: null, // opening-message
      //   klantId: null, // username of current contact (for preselecting)
      modalInstance: null // modal instance to close if opened
    };

    // Current OutBound-Call Information
    var outgoing = {
      phonenumber: null, // number to call
      agendaCaption: null, // agenda-caption
      agendaId: null, // agenda id
      contactInfoType: null,  // type of contact
      caption: null, // caption of contact
      userId: null, // User of Contact
      immediate: true, // make immediate-call on click
      invoiced: true // invoice the outgoing call
    };

    // service
    var service = {
      registerWebsocket: registerWebsocket,
      answer: answer,
      decline: decline,
      showDialModal: showDialModal,
      call: call,
      outgoing: outgoing,
      incomingCall: incomingCall,
      pauseWrapUp: pauseWrapUp,
      stopWrapUp: stopWrapUp,
      deselect: deselect,
      deselectCaller: deselectCaller,
      setGuidToEntity: setGuidToEntity,
      closeModal: closeModal,
      phoneStatus: phoneStatus,
      changeToAgenda: changeToAgenda};

    return service;

    // register websocket call
    function registerWebsocket() {
      // clean
      call.with = null;
      call.wrapUp.start = false;
      call.wrapUp.time = null;
      call.modalInstance = null;
      call.opening = null;
      call.selected = null;
      call.caller = null;
      call.phoneStatus = null;
      call.talkingTo = null;

      // deregister websocket callbacks
      ws.forEach(function (wscb) {
        if (wscb) {
          WebsocketService.unregister(wscb.id);
        } //if
      });
      ws = [];

      // new INCOMING call 
      var wsnc = WebsocketService.register(WebsocketRegisterType.NewCall, function (jObject) {

        /// Data-Structure
        ///     type => Type Of WebSocket-Call
        ///     info => Unique-Id Of Websocket-Ivr-Operator
        ///     data => Data of Contact, Patients, User

        // save the information
        call.with = jObject;

        // show info on new-call
        newCall();

      });

      ws.push(wsnc);

      // new OUTGOING Call was made
      var wsno = WebsocketService.register(WebsocketRegisterType.NewOutgoingCall, function (jObject) {

        /// Data-Structure
        ///     type => Type Of WebSocket-Call
        ///     info => Unique-Id Of Websocket-Ivr-Operator
        ///     data => Data of Contact

        // save the information -> talking-to
        call.with = jObject;

        call.talkingTo = outgoing.phonenumber;

      });

      ws.push(wsno);

    } // registerWebsocket 


    // change/switch to Agenda 
    function changeToAgenda() {

      // On "CONNECTED" Change To Agenda And Show Protocols and Warnings
      if (call.phoneStatus !== CallPhoneStatus.CONNECTED) { return; } // do nothing

      // change to new agenda of selected user
      if (call.selected !== null) {
        // close modal
        closeModal();

        // agenda change
        AgendaTransitionService.change(call.selected.id).then(function (result) {

          // show "incoming-call-protocol"
          ProtocolBroadcastService.broadcast(ProtocolFilter.ShowOnInboundCall);

          // // show warnings of patients
          // WarningService.showWarningOfPatients(call.selected.id, call.talkingTo);
        });
      } // if 
    } // changeToAgenda

    // phone status changed
    function phoneStatus(jObject) {
      /// Data-Structor To Send
      ///     type => Type Of WebSocket-Call
      ///     info => PhoneStatus (CONNECTED, IDLE)

      // set new phone-status
      call.phoneStatus = jObject.info;

      if (call.phoneStatus === CallPhoneStatus.RINGING) {
        // open new modal
        call.modalInstance = $uibModal.open({
          backdrop: 'static',
          keyboard: false,
          windowClass: 'quick-sidebar-modal',
          animation: true,
          controller: 'NewCallModalController',
          controllerAs: 'vm',
          templateUrl: '/app/ringfoon/templates/new-call-modal.template.html',
          size: 'lg'
        });
        return;
      } // if

      // On "IDLE" Close Modal
      if (call.phoneStatus === CallPhoneStatus.IDLE) {
        closeModal();
        return;
      } // do nothing

      // switch to agenda
      changeToAgenda();

    } // phoneStatus

    // call the number (show modal for sms, call, warnings)
    function showDialModal() {
      // if not Ringfoon AND type is PHONE -> do nothing
      if (!$rootScope.isRingfoon && outgoing.contactInfoType === "1") { return; }

      // protocols only for ringfoon
      if ($rootScope.isRingfoon) {
        // show protocols on "Outbound-Calls"
        ProtocolBroadcastService.broadcast(ProtocolFilter.ShowOnOutboundCall);
      } // if

      // close other modals if open
      $uibModalStack.dismissAll();

      // immediate call number ?
      if ($rootScope.isRingfoon && (outgoing.immediate === true || outgoing.immediate === 'true')) {
        outgoing.invoiced = true;
        dial();
        return;
      }

      // open new modal
      var modal = $uibModal.open({
        backdrop: 'static',
        keyboard: true,
        animation: true,
        controller: 'DialModalController',
        controllerAs: 'vm',
        templateUrl: '/app/ringfoon/templates/dial-modal.template.html',
        size: 'xs'
      });


      // when modal is closed
      modal.result.then(function () {
        dial();
      }, function () {
        // dismissed

      });
    } // showDialModal

    function dialNumber(isPrivate) {
      const virtualNumber = SharedAgendaService.data.client.detail.virtualNumber;
      const billingCode = SharedAgendaService.data.client.detail.billingCode;
      const trunk = SharedAgendaService.data.client.detail.sipTrunk;
      const invoiced = isPrivate ? (outgoing.invoiced ? '2' : '9') : '1';
      const prefix = isPrivate ? '*7*11' : '*7*10';
      let number = '';
      if (billingCode) {
        const paddedBillingCode = String(billingCode).padStart(5, '0');
        number = prefix + trunk + paddedBillingCode + invoiced + '*' + outgoing.phonenumber;
      } else if (virtualNumber) {
        number = prefix + trunk + virtualNumber + invoiced + '*' + outgoing.phonenumber;
      } else {
        number = prefix + trunk + '00000' + invoiced + '*' + outgoing.phonenumber;
        
        $uibModal.open({
          backdrop: 'static',
          keyboard: false,
          windowClass: 'quick-sidebar-modal',
          animation: true,
          controller: 'WarnCallNotInvoicedController',
          controllerAs: 'vm',
          templateUrl: '/app/ringfoon/templates/warn-call-not-invoiced-modal.template.html',
          size: 'xl'
        });
      }

      if (isPrivate) {
        cmdTapiDialNew(number);
      } else {
        cmdTapiAuto(number, virtualNumber);
      }
    }

    function dialWithPrivateNumber() { dialNumber(true); }

    function dialWithPublicNumber() { dialNumber(false); }

    // dial number
    function dial() {
      call.selected = null;
      // send DIAL-Command

      /***********************************************************************************************/
      /* Websocket dialling is currently disabled: we make calls through the old Voxtron API (cmdTapiDialNew)  */
      /***********************************************************************************************/

      if (outgoing.immediate) {
        dialWithPublicNumber();
      } else {
        dialWithPrivateNumber();
      }

      // // transfer object
      // var transfer = {
      //     type: WebsocketRegisterType.Dial,
      //     data: {
      //         userId: outgoing.userId,
      //         phoneNumber: outgoing.phonenumber,
      //         virtualNumber: SharedAgendaService.data.client.detail.virtualNumber,
      //         invoiced: outgoing.invoiced
      //     }
      // };

      // // send
      // send(transfer);
    } // dial

    // answer call
    function answer() {
      // make websocket call to answer call

      // No more Information needed
      var transfer = {
        type: WebsocketRegisterType.AnswerCall,
        info: call.with.info // unique-websocket-id of ivr-operator
      };

      // send 
      send(transfer);

      // proof the virtual number -> if different -> send updateVirtualNumber-Event
      if (call.selected && call.selected.virtualNumber !== call.with.data.contact.contactTo) {
        var updateTransfer = {
          type: WebsocketRegisterType.UpdateVirtualNumber,
          info: call.with.info, // unique-websocket-id of ivr-operator
          data: {
            guid: call.with.data.contact.guid,
            virtualNumber: call.selected.virtualNumber
          }
        };

        send(updateTransfer);
      }

    } // answer

    // decline call (hang-up)
    function decline() {
      // make websocket call to decline call

      // No more Informatin needed
      var transfer = {
        type: WebsocketRegisterType.DeclineCall,
        info: call.with.info // unique-websocket-id of ivr-operator
      };
      // send 
      send(transfer);
    } // decline

    // close the modal
    function closeModal() {
      // close modal
      if (call.modalInstance) {
        call.modalInstance.close();
        call.modalInstance = null;
      }
    } // closeModal

    // pausing the wrap up
    function pauseWrapUp() {
      // make transfer object

      /// Data-Structure
      /// info => Unique-Websocket-Id of Ivr-Operator
      /// data => ContactId

      var transfer = {
        type: WebsocketRegisterType.PauseWrapUp,
        info: call.with.info, // unique-websocket-id of ivr-operator
        data: call.with.data.contact.guid // contactId
      };

      send(transfer);
    } // pauseWrapUp

    // stop the wrap up immediate
    function stopWrapUp() {
      // make transfer object

      /// Data-Structure
      /// type => of Websocket-call
      /// info => Unique-Websocket-Id of Ivr-Operator
      /// data => ContactId

      var transfer = {
        type: WebsocketRegisterType.StopWrapUp,
        info: call.with.info, // unique-websocket-id of ivr-operator
        data: call.with.data.contact.guid // contactId
      };

      send(transfer);
    } // stopWrapUp


    // send by websocket
    function send(transfer) {
      // send 
      WebsocketService.send(transfer);
    } // send

    // new call is coming in -> show modal with call-information
    function newCall() {
      // show modal with new-call-information
      call.phoneStatus = 'BUSY'; // default
      call.wrapUp.start = false;
      call.opening = null;
      call.selected = null;
      call.caller = null;
      call.talkingTo = null;

      // set talking-to-phone-number
      call.talkingTo = call.with.data.contact.contactFrom;

      // get current username (klant-id) and opening-message            
      var i = 0;
      var len = call.with.data.contact.properties.items.length;
      for (i; i < len; i++) {
        if (call.with.data.contact.properties.items[i].propertyName === "Opening") {
          call.opening = call.with.data.contact.properties.items[i].propertyValue;
        }
      } // for


      // close other modals if open
      $uibModalStack.dismissAll();

      // open new modal
      call.modalInstance = $uibModal.open({
        backdrop: 'static',
        keyboard: false,
        windowClass: 'quick-sidebar-modal',
        animation: true,
        controller: 'NewCallModalController',
        controllerAs: 'vm',
        templateUrl: '/app/ringfoon/templates/new-call-modal.template.html',
        size: 'xl'
      });

    } // newCall


    // deselect user
    function deselect() {
      if (call.with === null) { return; }
      call.selected = null;
      // deselect all
      call.with.data.user.forEach(function (user) {
        user.selected = false;
      });
    } // deselect user


    // deselect "patients"/"caller"
    function deselectCaller() {
      if (call.with === null) { return; }
      call.caller = null;
      // deselect all caller
      call.with.data.patients.forEach(function (caller) {
        caller.selected = false;
      });
    } // deselectCaller

    // set call-guid and number to entity
    function setGuidToEntity(entity) {
      if (call.with !== null && call.phoneStatus === CallPhoneStatus.CONNECTED) {
        entity.callGuid = entity.callGuid === null ? call.with.data.contact.guid : entity.callGuid + call.with.data.contact.guid + ";";
        entity.callerNumber = entity.callerNumber === null ? call.with.data.contact.contactFrom : entity.callerNumber + call.with.data.contact.contactFrom + ";";
      } // if
      return entity;
    } //setGuidToEntity
  }
})();